export const orderStatusMap = {
  created: {
    class: "bg-warning",
    label: "Created",
  },
  pending: {
    class: "bg-warning",
    label: "Pending",
  },
  confirmed: {
    class: "bg-info",
    label: "Confirmed",
  },
  processing: {
    class: "bg-primary",
    label: "Processing",
  },
  shipped: {
    class: "bg-secondary",
    label: "Shipped",
  },
  out_for_delivery: {
    class: "bg-info",
    label: "Out For Delivery",
  },
  delivered: {
    class: "bg-success",
    label: "Delivered",
  },
  cancelled: {
    class: "bg-danger",
    label: "Cancelled",
  },
  returned: {
    class: "bg-dark",
    label: "Returned",
  },
  payment_failed: {
    class: "bg-danger",
    label: "Payment Failed",
  },
};
  
export const paymentStatusMap = {
  initiated: {
    class: "bg-info",
    label: "Initiated",
  },
  pending: {
    class: "bg-warning",
    label: "Pending",
  },
  paid: {
    class: "bg-success",
    label: "Paid",
  },
  failed: {
    class: "bg-danger",
    label: "Failed",
  },
  cancelled: {
    class: "bg-danger",
    label: "Cancelled",
  },
  partially_refunded: {
    class: "bg-secondary",
    label: "Partially Refunded",
  },
  refunded: {
    class: "bg-dark",
    label: "Refunded",
  },
};